"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlTextTransformer = void 0;
const HtmlParser_1 = require("../../translations/translationsTransformer/HtmlParser");
class HtmlTextTransformer {
    constructor(parseNodeFn, nodeProvider = new HtmlParser_1.HtmlParser()) {
        this.parseNodeFn = parseNodeFn;
        this.nodeProvider = nodeProvider;
    }
    createElement(type, attributes = [], children = null) {
        return this.parseNodeFn(type.toLowerCase(), attributes, children);
    }
    getAttributes(node) {
        const attributeNames = node.getAttributeNames();
        const attributes = [];
        if (attributeNames.length) {
            for (const name of attributeNames) {
                attributes.push({ attribute: name, value: node.attributes[name].value });
            }
        }
        return attributes;
    }
    // eslint-disable-next-line complexity
    getComponents(nodes) {
        const levelChildren = [];
        for (const node of nodes) {
            const { nodeName, nodeValue } = node;
            if (nodeName === 'BR') {
                levelChildren.push(this.createElement(nodeName));
            }
            if (nodeName === '#text') {
                levelChildren.push(nodeValue || node.innerText);
            }
            else if (node.hasChildNodes()) {
                const attributes = this.getAttributes(node);
                const children = node.childNodes;
                if (children.length === 1 && !children[0].childNodes.length) {
                    const child = children[0];
                    levelChildren.push(this.createElement(nodeName, attributes, child.nodeValue || node.innerText));
                }
                else {
                    levelChildren.push(this.createElement(nodeName, attributes, this.getComponents(children)));
                }
            }
        }
        return levelChildren;
    }
    resolve(htmlText) {
        const children = this.nodeProvider.getNodes(htmlText);
        return this.getComponents(children);
    }
}
exports.HtmlTextTransformer = HtmlTextTransformer;
//# sourceMappingURL=HtmlTextTransformer.js.map